import { ValueType } from 'realgrid';

// 데이터 필드 정의
const fieldsWWY = [
  { fieldName: '구분', dataType: ValueType.TEXT },
  { fieldName: '고객사원료명칭', dataType: ValueType.TEXT },
  { fieldName: '사내통용명칭', dataType: ValueType.TEXT },
  { fieldName: '조성비', dataType: ValueType.TEXT },
  { fieldName: 'Mw', dataType: ValueType.TEXT },
  { fieldName: 'Density', dataType: ValueType.TEXT },
  { fieldName: 'VVRatio1', dataType: ValueType.TEXT }, // 새로운 필드: (2)/(4)
  { fieldName: 'VVRatio2', dataType: ValueType.TEXT }, // 새로운 필드: (5)/(5-1)*100
  { fieldName: 'Weight', dataType: ValueType.TEXT },
  { fieldName: 'Volume', dataType: ValueType.TEXT },
  { fieldName: 'VolSolv1', dataType: ValueType.TEXT },
  { fieldName: 'VolSolv2', dataType: ValueType.TEXT },
  { fieldName: 'WeightSolv', dataType: ValueType.TEXT },
  { fieldName: 'CalcWeight', dataType: ValueType.TEXT },
  { fieldName: 'Base100_1', dataType: ValueType.TEXT },
  { fieldName: 'Base100_2', dataType: ValueType.TEXT },
  { fieldName: 'WithAdd', dataType: ValueType.TEXT },
  { fieldName: 'WithAddBase1', dataType: ValueType.TEXT },
  { fieldName: 'WithAddBase2', dataType: ValueType.TEXT },
  { fieldName: 'changeYn', dataType: ValueType.TEXT },
];

// 컬럼 정의
const columnsWWY = [
  {
    name: '구분',
    fieldName: '구분',
    width: 50,
    editable: false,
    header: { text: '구분' },
    styles: { textAlignment: 'center' },
    mergeRule: { criteria: 'value' },
  },
  {
    name: '고객사원료명칭',
    fieldName: '고객사원료명칭',
    width: 80,
    editable: false,
    header: { text: '고객사원료명칭' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '사내통용명칭',
    fieldName: '사내통용명칭',
    width: 60,
    editable: false,
    header: { text: '사내통용명칭' },
    styles: { textAlignment: 'center' },
  },
  {
    name: '조성비',
    fieldName: '조성비',
    width: 50,
    editable: false,
    header: { text: '조성비' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Mw',
    fieldName: 'Mw',
    width: 60,
    editable: false,
    header: { text: 'Mw(g/mol)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Density',
    fieldName: 'Density',
    width: 60,
    editable: false,
    header: { text: 'Density(g/cm³)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'VVRatio1',
    fieldName: 'VVRatio1',
    width: 60,
    editable: false,
    header: { text: '(2)/(4)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'VVRatio2',
    fieldName: 'VVRatio2',
    width: 80,
    editable: false,
    header: { text: '(5)/(5-1)*100' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Weight',
    fieldName: 'Weight',
    width: 60,
    editable: false,
    header: { text: '(2)*(3)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Volume',
    fieldName: 'Volume',
    width: 60,
    editable: false,
    header: { text: '(7)/(4)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'VolSolv1',
    fieldName: 'VolSolv1',
    width: 80,
    editable: false,
    header: { text: '1000ml-(8-1)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'VolSolv2',
    fieldName: 'VolSolv2',
    width: 80,
    editable: false,
    header: { text: '(9)*(6)/(6-1)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WeightSolv',
    fieldName: 'WeightSolv',
    width: 80,
    editable: false,
    header: { text: '(4)*(10)' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'CalcWeight',
    fieldName: 'CalcWeight',
    width: 80,
    editable: false,
    header: { text: '각 용매의 질량' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Base100_1',
    fieldName: 'Base100_1',
    width: 80,
    editable: false,
    header: { text: '(12)/(12-1)*100' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Base100_2',
    fieldName: 'Base100_2',
    width: 80,
    editable: false,
    header: { text: '소수점 조정' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WithAdd',
    fieldName: 'WithAdd',
    width: 80,
    editable: false,
    header: { text: '첨가제 합산' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WithAddBase1',
    fieldName: 'WithAddBase1',
    width: 160,
    editable: false,
    header: { text: '(15)/(15-1)*100' },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WithAddBase2',
    fieldName: 'WithAddBase2',
    width: 160,
    editable: false,
    header: { text: '소수점 조정' },
    styles: { textAlignment: 'center' },
  },
];

// 3단 헤더 레이아웃 정의
const columnLayoutWWY = [
  // 첫 번째, 두 번째 컬럼은 단독으로 3행 span
  '구분',
  '고객사원료명칭',

  // (1) 사내통용명칭 그룹
  {
    name: 'group1',
    direction: 'horizontal',
    header: { text: '(1)' },
    items: ['사내통용명칭'],
  },

  // (2) 조성비 그룹
  {
    name: 'group2',
    direction: 'horizontal',
    header: { text: '(2)' },
    items: ['조성비'],
  },

  // (3) Mw 그룹
  {
    name: 'group3',
    direction: 'horizontal',
    header: { text: '(3)' },
    items: ['Mw'],
  },

  // (4) Density 그룹
  {
    name: 'group4',
    direction: 'horizontal',
    header: { text: '(4)' },
    items: ['Density'],
  },

  // (5) v/v Ratio 그룹 - 새로 추가
  {
    name: 'group5',
    direction: 'horizontal',
    header: { text: '(5)' },
    items: [
      {
        name: 'subgroup5',
        direction: 'horizontal',
        header: { text: 'v/v Ratio' },
        items: ['VVRatio1'],
      },
    ],
  },

  // (6) v/v Ratio 그룹 - 새로 추가
  {
    name: 'group6',
    direction: 'horizontal',
    header: { text: '(6)' },
    items: [
      {
        name: 'subgroup6',
        direction: 'horizontal',
        header: { text: 'v/v Ratio' },
        items: ['VVRatio2'],
      },
    ],
  },

  // (7) Weight 그룹
  {
    name: 'group7',
    direction: 'horizontal',
    header: { text: '(7)' },
    items: [
      {
        name: 'subgroup7',
        direction: 'horizontal',
        header: { text: 'Weight' },
        items: ['Weight'],
      },
    ],
  },

  // (8) Volume 그룹
  {
    name: 'group8',
    direction: 'horizontal',
    header: { text: '(8)' },
    items: [
      {
        name: 'subgroup8',
        direction: 'horizontal',
        header: { text: 'Volume' },
        items: ['Volume'],
      },
    ],
  },

  // (9) Volume of Solvent 그룹
  {
    name: 'group9',
    direction: 'horizontal',
    header: { text: '(9)' },
    items: [
      {
        name: 'subgroup9',
        direction: 'horizontal',
        header: { text: 'Volume of Solvent' },
        items: ['VolSolv1'],
      },
    ],
  },

  // (10) Volume of Solvent 그룹
  {
    name: 'group10',
    direction: 'horizontal',
    header: { text: '(10)' },
    items: [
      {
        name: 'subgroup10',
        direction: 'horizontal',
        header: { text: 'Volume of Solvent' },
        items: ['VolSolv2'],
      },
    ],
  },

  // (11) Weight of solvent 그룹
  {
    name: 'group11',
    direction: 'horizontal',
    header: { text: '(11)' },
    items: [
      {
        name: 'subgroup11',
        direction: 'horizontal',
        header: { text: 'Weight of solvent' },
        items: ['WeightSolv'],
      },
    ],
  },

  // (12) Calculated weight 그룹
  {
    name: 'group12',
    direction: 'horizontal',
    header: { text: '(12)' },
    items: [
      {
        name: 'subgroup12',
        direction: 'horizontal',
        header: { text: 'Calculated weight' },
        items: ['CalcWeight'],
      },
    ],
  },

  // (13) weight of 100 g base 그룹
  {
    name: 'group13',
    direction: 'horizontal',
    header: { text: '(13)' },
    items: [
      {
        name: 'subgroup13',
        direction: 'horizontal',
        header: { text: 'weight of 100 g base' },
        items: ['Base100_1'],
      },
    ],
  },

  // (14) weight of 100 g base 그룹
  {
    name: 'group14',
    direction: 'horizontal',
    header: { text: '(14)' },
    items: [
      {
        name: 'subgroup14',
        direction: 'horizontal',
        header: { text: 'weight of 100 g base' },
        items: ['Base100_2'],
      },
    ],
  },

  // (15) Weight with Additives 그룹
  {
    name: 'group15',
    direction: 'horizontal',
    header: { text: '(15)' },
    items: [
      {
        name: 'subgroup15',
        direction: 'horizontal',
        header: { text: 'Weight with Additives' },
        items: ['WithAdd'],
      },
    ],
  },

  // (16) Weight of 100 g base (with Additives) 그룹
  {
    name: 'group16',
    direction: 'horizontal',
    header: { text: '(16)' },
    items: [
      {
        name: 'subgroup16',
        direction: 'horizontal',
        header: { text: 'Weight of 100 g base (with Additives)' },
        items: ['WithAddBase1'],
      },
    ],
  },

  // (17) Weight of 100 g base (with Additives) 그룹
  {
    name: 'group17',
    direction: 'horizontal',
    header: { text: '(17)' },
    items: [
      {
        name: 'subgroup17',
        direction: 'horizontal',
        header: { text: 'Weight of 100 g base (with Additives)' },
        items: ['WithAddBase2'],
      },
    ],
  },
];

const rowSet = [];
const errorMessageWWY = '질량비 계산 데이터가 없습니다';
const hideCheckBarWWY = true;
const blankGridWWY = true;

export { fieldsWWY, columnsWWY, columnLayoutWWY, rowSet, errorMessageWWY, hideCheckBarWWY, blankGridWWY };
